import projects01 from './../img/projects/01.jpg';
import projects01Big from './../img/projects/01-big.jpg';

import projects02 from './../img/projects/02.jpg';
import projects02Big from './../img/projects/02-big.jpg';

import projects03 from './../img/projects/03.jpg';
import projects03Big from './../img/projects/03-big.jpg';

import projects04 from './../img/projects/04.jpg';
import projects04Big from './../img/projects/04-big.jpg';

import projects05 from './../img/projects/05.jpg';
import projects05Big from './../img/projects/05-big.jpg';

import projects06 from './../img/projects/06.jpg';
import projects06Big from './../img/projects/06-big.jpg';

const projects = [
    {
        title: 'Gaming streming portal',
        skills: 'React, Node.js, MongoDB',
        img: projects01,
        imgbig: projects01Big,
        gitHubLink: 'https://github.com',
    },
    {
        title: 'Video service',
        skills: 'React, PHP, MySql',
        img: projects02,
        imgbig: projects02Big,
        gitHubLink: 'https://github.com',
    },
    {
        title: 'Video portal',
        skills: 'Vue JS, Node.js, MongoDB',
        img: projects03,
        imgbig: projects03Big,
        gitHubLink: 'https://github.com',
    },
    {
        title: 'Dating app',
        skills: 'React Native',
        img: projects04,
        imgbig: projects04Big,
    },
    {
        title: 'Landing',
        skills: 'HTML, SCSS, JS',
        img: projects05,
        imgbig: projects05Big,
    },
    {
        title: 'Gaming community',
        skills: 'React, PHP, MySql',
        img: projects06,
        imgbig: projects06Big,
    },
 
]
export {projects};